/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'public-status-page',
  title: 'Your public status page',
  category: 'Status pages',
  summary:
    'What visitors see on your public status page: the overall banner, per-component status, the 90-day history and upcoming maintenance.',
  keywords: ['status page', 'public', 'uptime', '90 days', 'operational', 'degraded', 'share'],
};

export const loadComponent = () => import('./public-status-page.component').then((m) => m.PublicStatusPageArticleComponent);
